import { DVIRReport, QuestionAnswer } from "../../../models";

const getQuestionAnswer = (data: any): QuestionAnswer => {
  return {
    questionId: data.question_id,
    question: data.question,
    isRequired: data.is_required,
    answer: data.answer || "",
  };
};

export const getDVIRReport = (data: any): DVIRReport => {
  const attrs = data.attributes;
  return {
    id: data.id,
    templateId: attrs.template_id,
    vehicleId: attrs.vehicle_id,
    driverId: attrs.driver_id,
    date: attrs.date,
    questionAnswers: attrs.question_answers
      ? attrs.question_answers.map(getQuestionAnswer)
      : [],
    status: attrs.status,
    submittedAt: attrs.submitted_at,
    templateName: attrs.template_name || "",
    templateType: attrs.template_type || "pre_trip",
    driverName: attrs.driver_name || "",
    vehicleLabel: attrs.vehicle_label || "",
  };
};

export const getDVIRReports = (data: any): DVIRReport[] => {
  return data.map(getDVIRReport);
};
